import { render, staticRenderFns } from "./mainComponents.vue?vue&type=template&id=40b6c45b&scoped=true"
import script from "./mainComponents.vue?vue&type=script&lang=js"
export * from "./mainComponents.vue?vue&type=script&lang=js"
import style0 from "./index.css?vue&type=style&index=0&id=40b6c45b&prod&scoped=true&lang=css&external"
import style1 from "./mainComponents.vue?vue&type=style&index=1&id=40b6c45b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_cache-loader@4.1.0_webpack@4.47.0__css-load_71321242e37ff7a0c7584d931db29eba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b6c45b",
  null
  
)

export default component.exports